import { NgModule } from '@angular/core';

// ----- Common -----
import { CommonModule } from '@angular/common';

// ----- Forms -----
import { FormsModule } from '@angular/forms';

// ----- Kendo-Grid Module -----
import { ExcelModule, GridModule } from '@progress/kendo-angular-grid'; 
import { RegistrationFormComponent } from './registration-form.component';
 
@NgModule({
  imports: [
    CommonModule, FormsModule, GridModule, ExcelModule
  ],
  declarations: [
    RegistrationFormComponent
  ],
  exports: [
    RegistrationFormComponent
  ],
  providers: [
    
  ]
})
export class RegistrationFormModule { }
